export const settingsMutations = {
    setLanguages: "settings/setLanguages"
}
